<template>
    <div>
        <navigation-bar Close/>
        <div class="customerService main">
            <custom-card>
                <el-row type="flex" justify="center">
                    <el-col :span="4">
                        <img src="@/assets/images/customerService.svg" alt=""/>
                    </el-col>
                </el-row>
                <p class="strongTitle">請問有什麼是我們可以幫助您?</p>
                <div class="listItem">
                    <div v-if="false" @click="$router.push({name: 'ServiceProcess'})" class="list-header">
                        <div class="list-title">客服處理進度</div>
                        <div
                                class="ml-auto mr-1 status"
                                :class="customerServiceClaim ? 'claim-on' : 'claim-off'"
                        >
                            您沒有最近的要求
                        </div>
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
            </custom-card>
            <div v-for="(item, index) in dataList" :key="index">
                <p :class=" item.categoryName !== '' ? 'strongTitle': '' ">{{ item.categoryName }}</p>
                <el-collapse v-model="activelistItem" accordion class="listGroup">
                <el-collapse-item
                        v-for="(dataItem, key) in item.data"
                        :key="key"
                        class="listItem"
                >
                    <template slot="title">
                        <div class="list-title">{{ dataItem.question }}</div>
                    </template>
                    <div class="list-content">
                        <p class="font-weight-light">
                            <slot/>
<!--                            {{ item.content.caption }}-->
                        </p>
                        <div v-html="dataItem.ask">
                            <slot/>
                            <!-- {{ item.content.description }} -->
                        </div>
                        <el-divider v-if="false" class="vw-100">資訊是否有幫助到您?</el-divider>
                        <el-row v-if="false" class="mb-3">
                            <el-button plain class="feedback-btn w-100"
                            >已得到需要的答案
                            </el-button
                            >
                        </el-row>
                        <el-row v-if="false">
                            <el-button plain class="feedback-btn w-100"
                            >沒有幫助，請告訴我們
                            </el-button
                            >
                        </el-row>
                    </div>
                </el-collapse-item>
            </el-collapse>
            </div>

            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true">
            </loading>
        </div>
    </div>
</template>

<script>
    import CustomCard from "@/components/CustomCard.vue";
    import {notNull} from "@/util/common";

    export default {
        name: "Service",
        components: {
            CustomCard,
        },
        data() {
            return {
                activelistItem: "0",
                customerServiceClaim: false,
                dataList: [],
                isLoading: false,
            };
        },
        created() {
            this.setupData();
        },
        mounted() {
        },
        methods: {
            setupData: function () {
                this.isLoading = true;
                //問題列表
                this.$http.fetch`QuestionAndAskList${{}} ${json => {
                    if (notNull(json.data)) {
                        this.dataList = json.data;
                    }
                    this.isLoading = false;
                }}`;
            }
        },
    };
</script>

<style lang="less" scoped src="@/less/service.less"/>